import { useMemo, useState } from "react";
import { getApplicationsApi } from "../../../services/apis/applicationApis";
import { toastError } from "../../../utils/toastUtils";

const useOrgApps = (orgId) => {
  const [allOrgApps, setAllOrgApps] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchApps = async (signal) => {
    try {
      setIsLoading(true);

      const response = await getApplicationsApi({ orgId, signal });
      const data = response?.data;

      console.log(data);

      setAllOrgApps(data || []);
    } catch (error) {
      if (error.name === "CanceledError") return;
      toastError(error?.response?.data?.message || "Failed to fetch apps");
    } finally {
      setIsLoading(false);
    }
  };

  const appOptions = useMemo(
    () =>
      allOrgApps.map((app) => ({
        value: app.id,
        label: app.name
      })),
    [allOrgApps]
  );

  return { appOptions, isLoading, fetchApps };
};

export default useOrgApps;
